import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';

function Laverage(props) {
    return (
        <div className="laverage_section laverage_startup p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                        <h2>How Tekrevol Helps Startup Apps Standout</h2>
                        <p>We rethink innovation and come up with the perfect mobile blueprint from the start. In a matter of a few weeks, your startup app's initial development and a designing plan are fully mapped-out and presented to you.</p>
                        <p>Our approach and process heavily rely on market and competitor research, gap analysis, integrating revolutionary functionalities, and leveraging modern technologies to develop your Startup app.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
                        <div className="process_listing">
                            <div className="process_item">
                                <div className="number">01</div>
                                <h6>Comprehensive Mobile App Strategy</h6>
                            </div>
                            <div className="process_item">
                                <div className="number">02</div>
                                <h6>UX Design Sketches & Prototype</h6>
                            </div>
                            <div className="process_item">
                                <div className="number">03</div>
                                <h6>Complete Product Roadmap & Presentation Deck</h6>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Laverage;